/*
 * File: cell-string.ts
 * File Created: 2023-12-18 04:51:11
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-10-14 09:28:11
 * Modified By: Val Liu
 * -----
 */

import { Component, Prop } from "vue-property-decorator";
import { BaseTableBodyCell } from "../../../core/lib/base-table-body-cell/base-table-body-cell";
import { AnyHelper, DateHelper, NumberHelper } from "@root/core";
import { UITag } from "@root/core/tags";

export interface ICellAnyData {
    "text-empty": string;
}
const defaultData: ICellAnyData = {
    "text-empty": "w_CellNullText",
};

@Component
@UITag.setDefault({
    uiSort: true,
    uiSearch: true,
})
export default class CellString extends BaseTableBodyCell {
    @Prop({ type: Object, required: false })
    declare data: ICellAnyData;
    get mergedData() {
        return {
            ...defaultData,
            ...this.data,
        };
    }
}
